import React from 'react';
import { XIcon, CheckIcon } from 'lucide-react';
import { letterBlocks, painPoints, solutionPoints } from '../data/content';
export function SalesLetter() {
  return <section className="w-full border-y border-ink-800 bg-ink-900 py-20" aria-labelledby="carta" style={{
    paddingTop: "20px",
    paddingBottom: "20px"
  }} data-id="element-178" data-mp="3uw3vghfeiyym">
      <div className="mx-auto w-full max-w-5xl px-4 sm:px-6" data-id="element-179" data-mp="3lue5lg16482y">
        <h2 id="carta" className="max-w-4xl font-display text-3xl font-900 leading-tight text-white sm:text-[2.6rem]" style={{
        fontSize: "24px"
      }} data-id="element-180" data-mp="mdplo1yu8fvf">
          Si tu factura de luz sigue subiendo cada mes y estás pensando en energía solar, esta es la información más importante que vas a ver este año.
        </h2>

        <div className="mt-12 grid gap-12 lg:grid-cols-[1.05fr_0.95fr] lg:items-start" data-id="element-181" data-mp="8lhsslaod920">
          <div className="space-y-10" data-id="element-182" data-mp="1626ri64bvv76">
            {letterBlocks.map(block => <div key={block.kicker} data-id="element-183" data-mp="163rjbnz9d01c">
                <p className="font-display text-[11px] font-700 uppercase tracking-[0.28em] text-gold" data-id="element-184" data-mp="11aykfgqh0lx6">
                  {block.kicker}
                </p>
                <div className="mt-3 space-y-4" data-id="element-185" data-mp="2n414klszlr76">
                  {block.paragraphs.map(paragraph => <p key={paragraph} className="text-[17px] leading-relaxed text-slate-300" data-id="element-186" data-mp="2s2vue7pdgg0s">
                      {paragraph}
                    </p>)}
                </div>
              </div>)}

            <div className="border-l-2 border-gold pl-5" data-id="element-187" data-mp="2i957364zebmo">
              <p className="font-display text-xl font-700 leading-snug text-white sm:text-2xl" data-id="element-188" data-mp="24axf7cmsy0id">
                Por eso existe El Código Solar 360°.
              </p>
              <p className="mt-3 text-[15px] leading-relaxed text-slate-300" data-id="element-189" data-mp="1vaikxnrv1b2q">
                No es un manual técnico lleno de fórmulas para ingenieros. Es el sistema completo que
                cualquier dueño de casa en España o Latinoamérica necesita para tomar la decisión
                solar más inteligente de su vida:
              </p>
              <ul className="mt-5 grid gap-2.5" data-id="element-190" data-mp="3totyqat6jytt">
                {solutionPoints.map(point => <li key={point} className="flex gap-2.5 text-[15px] leading-relaxed text-slate-200" data-id="element-191" data-mp="16hxuyete8qrr">
                    <CheckIcon className="mt-1 h-4 w-4 flex-none text-leaf-400" aria-hidden="true" data-id="element-192" data-mp="11ibezxm6kwf9" />
                    {point}
                  </li>)}
              </ul>
              <p className="mt-5 font-display text-sm font-700 uppercase tracking-[0.18em] text-gold" data-id="element-193" data-mp="shwliaz2cb0o">
                Sin ser técnico · Sin depender de nadie · Con total seguridad
              </p>
            </div>
          </div>

          <div className="rounded-2xl border border-ink-700 bg-ink-950 p-7 shadow-panel sm:p-8" data-id="element-194" data-mp="1l7mz8iws9aw9">
            <h3 className="font-display text-lg font-800 leading-snug text-white" data-id="element-195" data-mp="1getu3txek0jn">
              Quizá ya pediste un presupuesto. Y ahí apareció el problema real: nadie te explicó
              nada con claridad.
            </h3>
            <ul className="mt-6 space-y-3.5" data-id="element-196" data-mp="28xhawx5d8tex">
              {painPoints.map(point => <li key={point} className="flex gap-3 text-[15px] leading-relaxed text-slate-300" data-id="element-197" data-mp="244ep5b6tyo9a">
                  <XIcon className="mt-1 h-4 w-4 flex-none text-alert" aria-hidden="true" data-id="element-198" data-mp="2bhmb3zqy6udn" />
                  {point}
                </li>)}
            </ul>
            <p className="mt-6 border-t border-ink-800 pt-5 text-sm leading-relaxed text-slate-400" data-id="element-199" data-mp="2les2l93h4nee">
              Resultado: paralizado entre el miedo a equivocarte y las ganas de hacer algo diferente.
            </p>
          </div>
        </div>

        <div className="mt-14 grid gap-6 rounded-2xl border border-ink-800 bg-ink-950 p-8 sm:grid-cols-[auto_1fr] sm:items-center sm:gap-10" data-id="element-200" data-mp="2uef2trkgvn5v">
          <p className="font-display text-5xl font-900 leading-none text-gold" data-id="element-201" data-mp="2zc6vwowulfbn">+1.200</p>
          <div data-id="element-202" data-mp="347cschnvmcdz">
            <p className="text-[17px] leading-relaxed text-slate-200" data-id="element-203" data-mp="394cyston1h5m">
              familias en España y Latinoamérica ya tomaron el control de su energía con este
              sistema. Familias corrientes, sin conocimientos técnicos, que hoy producen su propia
              electricidad, cobran por su excedente y miran su factura con una sonrisa.
            </p>
            <p className="mt-4 font-display text-lg font-700 leading-snug text-white" data-id="element-204" data-mp="34ghhgmfylfnc">
              La pregunta no es si la energía solar es para ti. Es cuánto dinero más vas a regalarle
              a tu compañía eléctrica antes de actuar.
            </p>
          </div>
        </div>
      </div>
    </section>;
}